import { render, staticRenderFns } from "./menopausechart.vue?vue&type=template&id=062a2f29&scoped=true&"
import script from "./menopausechart.vue?vue&type=script&lang=js&"
export * from "./menopausechart.vue?vue&type=script&lang=js&"
import style0 from "./menopausechart.vue?vue&type=style&index=0&id=062a2f29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a2f29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062a2f29')) {
      api.createRecord('062a2f29', component.options)
    } else {
      api.reload('062a2f29', component.options)
    }
    module.hot.accept("./menopausechart.vue?vue&type=template&id=062a2f29&scoped=true&", function () {
      api.rerender('062a2f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/components/menopausechart.vue"
export default component.exports